import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL}/${process.env.NEXT_PUBLIC_API_VERSION}`,
  // baseURL: 'https://app.ultrafarma.com.br/api/v1',
  headers: {
    'x-api-authorization': `Basic ${process.env.NEXT_PUBLIC_API_AUTHORIZATION}`,
    // 'x-api-authorization': `Basic dWx0cmFmYXJtYTp1bHRyYWZhcm1h`,
    'Content-Type': 'application/json',
    'x-cv': 1,
    'x-loja-id': 6,

    // ULTRAFARMA
    // 'x-loja-id': 1,
  },
});

const apiV2 = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_API_URL}/v2`,
  // baseURL: 'https://app.ultrafarma.com.br/api/v1',
  headers: {
    'x-api-authorization': `Basic ${process.env.NEXT_PUBLIC_API_AUTHORIZATION}`,
    // 'x-api-authorization': `Basic dWx0cmFmYXJtYTp1bHRyYWZhcm1h`,
    'Content-Type': 'application/json',
    'x-cv': 1,
    'x-loja-id': 6,

    // ULTRAFARMA
    // 'x-loja-id': 1,
  },
});

export default api;

export { apiV2 };
